module.exports = __webpack_public_path__ + "static/img/login_logoNew.6570eba0.png";